import { RemoteAddCellphones } from "../../../../data/usecases/cellphone";
import { AddCellphones } from "../../../../domain/usecases/add-cellphones";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteAddCellphones = (): AddCellphones =>
  new RemoteAddCellphones(makeApiUrl("/cellphones/add-cellphones"), makeAxiosHttpClient());
